// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-label {
    margin-right: 15px;
}

.email-Input {
    margin-right: 1em;
    width: 17em;
}

.email-Input-searchBtn {
    margin-right: 15px;
    display: inline-block;
}

.container2 {
    background-color: #F1F1F1;
    border: solid 1px #d4d4d4;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 50px;
}

.search-button {
    background-color: #286090;
    color: white;
    padding: 3px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
}

.addBtn {
    margin-top: 15px;
}

.button-group {
    display: flex;
    justify-content: center;
    gap: 30px;
}

.row.grayBackground {
    margin-top: 15px;
    background-color: #F1F1F1;
    margin-bottom: 15px;
}

.center-content {
    margin: auto !important;
    text-align: center;
}

.form-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.form-group {
    flex: 1;
    margin-right: 20px;
}

.upload-input-file {
    margin: 10px 15px;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    background-color: #286090;
    padding: 10px;
    color: white;
    border-radius: 5px;
    border: none;
    cursor: pointer;
}

.upload-container {
    flex: 2;
    display: flex;
    align-items: center;
}

.upload-container label {
    margin-right: 10px;
}

.upload-container input {
    margin-right: 10px;
}

strong {
    font-family: "GothamBold", Arial, sans-serif !important;
    font-weight: normal !important;
}

.content {
    font-family: "GothamNarrowBook", Arial, sans-serif;
}

.file-container {
    border: 2px solid #0B2D71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}

.select-text {
    color: white;
    padding: 5px;
    background-color: #0B2D71;
    text-align: left;
    border-radius: 5px 5px 0 0;
    font-family: "GothamBold", Arial, sans-serif;
}

.text-padding {
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
}

#closeSuccessModal {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    text-align: right;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 20px;
}

#closeSuccessModal:hover {
    background-color: #0056b3;
}

.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;
}

.modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 35%;
    height: auto;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.b {
    float: left;
    padding-left: 400px;

}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/doa/temporary-doa/temporary-doa.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uDAAuD;IACvD,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,4EAA4E;AAChF;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,mBAAmB;;AAEvB;AACA,o5MAAo5M","sourcesContent":[".radio-label {\n    margin-right: 15px;\n}\n\n.email-Input {\n    margin-right: 1em;\n    width: 17em;\n}\n\n.email-Input-searchBtn {\n    margin-right: 15px;\n    display: inline-block;\n}\n\n.container2 {\n    background-color: #F1F1F1;\n    border: solid 1px #d4d4d4;\n    border-radius: 5px;\n    margin-bottom: 15px;\n    padding: 50px;\n}\n\n.search-button {\n    background-color: #286090;\n    color: white;\n    padding: 3px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-left: 10px;\n}\n\n.addBtn {\n    margin-top: 15px;\n}\n\n.button-group {\n    display: flex;\n    justify-content: center;\n    gap: 30px;\n}\n\n.row.grayBackground {\n    margin-top: 15px;\n    background-color: #F1F1F1;\n    margin-bottom: 15px;\n}\n\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n.form-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.form-group {\n    flex: 1;\n    margin-right: 20px;\n}\n\n.upload-input-file {\n    margin: 10px 15px;\n    font-size: 12px;\n    font-family: Roboto, sans-serif;\n    background-color: #286090;\n    padding: 10px;\n    color: white;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n}\n\n.upload-container {\n    flex: 2;\n    display: flex;\n    align-items: center;\n}\n\n.upload-container label {\n    margin-right: 10px;\n}\n\n.upload-container input {\n    margin-right: 10px;\n}\n\nstrong {\n    font-family: \"GothamBold\", Arial, sans-serif !important;\n    font-weight: normal !important;\n}\n\n.content {\n    font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.file-container {\n    border: 2px solid #0B2D71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.select-text {\n    color: white;\n    padding: 5px;\n    background-color: #0B2D71;\n    text-align: left;\n    border-radius: 5px 5px 0 0;\n    font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.text-padding {\n    padding-left: 2%;\n    padding-right: 2%;\n    padding-bottom: 1%;\n}\n\n#closeSuccessModal {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    text-align: right;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    margin: 10px 0;\n    cursor: pointer;\n    border-radius: 4px;\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n}\n\n#closeSuccessModal:hover {\n    background-color: #0056b3;\n}\n\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: transparent;\n}\n\n.modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 35%;\n    height: auto;\n    max-height: 300px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.b {\n    float: left;\n    padding-left: 400px;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
